module.exports = __webpack_public_path__ + "img/Backyard-paws-Website-2.b6661f2f.webp";